import request from "~/utils/http";
export default {
  takeList(data) {
    return request({
      url: "api/Coupon/TakeList",
      method: "post",
      data: data
    });
  }
};
